import { Component, Input, ElementRef, Optional, Self, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { Results, PlatformApiService, ResultFilter } from '../services/platform-api.service';
import { Account } from '../models/AccountModel';
import { InfiniteScrollSelectComponent, InfiniteScrollOption } from './infinite-scroll-select.component';
import { MatFormFieldControl } from '@angular/material/form-field';
import { FocusMonitor } from '@angular/cdk/a11y';
import { NgControl } from '@angular/forms';

@Component({
  selector: 'cw-assessments-dropdown',
  templateUrl: './infinite-scroll-select.component.html',
  styleUrls: ['./infinite-scroll-select.component.scss'],
  providers:[{provide: MatFormFieldControl, useExisting: AssessmentDropdownComponent}]
})
export class AssessmentDropdownComponent extends InfiniteScrollSelectComponent<number> {
  @Input() placeholder = 'Loading...'
  @Input() MultiSelection: string;
  @Input() planId: number;
  @Input() isInTrial: boolean;
  @Input() excludeTypeList: Array<string>;
  @Input() includeTypeList: Array<string>;
  @Output() stateChange: EventEmitter<any> = new EventEmitter();

  selectedValue: Assessment[] = new Array<Assessment>();
  _account: Account;
  searchData: string;

  constructor(private _apiService: PlatformApiService, fm: FocusMonitor, elRef: ElementRef<HTMLElement>,
    @Optional() @Self() ngControl: NgControl) {
    super(fm, elRef, ngControl);
  }

  searchFunction(currentFilters: ResultFilter) : Observable<Results<any>> {
    if (Object.keys(currentFilters.searchData).length != 0 ) {
      if (this.searchControl.value == '') {
        this.selectedValue = [];
      } else {
        this.stateChange.emit({ state: 'INITIAL_ASSESSMENTS', item: this.selectedValue, assessmentType: this.MultiSelection});
      }

      const newValue = currentFilters.searchData.assessment.split( /,\s*/ ).pop()
      currentFilters.searchData.assessment = newValue;
      this.searchData = currentFilters.searchData;
    }

    if(this.excludeTypeList) {
      currentFilters.searchData.excludeTypeList = this.excludeTypeList;
    }

    if(this.includeTypeList) {
      currentFilters.searchData.includeTypeList = this.includeTypeList;
    }

    if(this.planId && this.isInTrial != undefined) {
      currentFilters.searchData.planId = this.planId;
      currentFilters.searchData.isInTrial = this.isInTrial;
    }

    return this._apiService.getAssessments(currentFilters);
  }

  mapSearchResults(results: Results<any>) {
    if(results.count > 0) {
      this.options.next(results.results.map(result => {
        let isSelected = false;
        let selectedAssesment: any[] = [];
        if (this.searchControl.value) {
          if (Array.isArray(this.searchControl.value)) {
            selectedAssesment  = this.searchControl.value.filter(a=> a.description == result.name);
            if(selectedAssesment.length > 0) {
              isSelected = true;
            }
          } else {
            if(typeof this.searchControl.value === 'string') {
              isSelected = this.searchControl.value.split(/\s*,\s*/).includes(result.name);
              if(isSelected) {
                isSelected = true;
              }
            }
          }
        }
        return new InfiniteScrollOption(result.name, result.id, false, isSelected, true, this.searchData);
      }));
    } else {
      this.options.next([new InfiniteScrollOption('No results found.', null, true, false, true)]);
    }
    this.totalResults = results.count;
  }

  createResultsFilter(filter: string) {
    const resultFilter = new ResultFilter();
    resultFilter.searchData.assessment = filter;
    return resultFilter;
  }

  optionClicked(event: Event, assessmentType: Assessment) {
    event.stopPropagation();
    this.toggleSelection(assessmentType);
  }

  toggleSelection(assessmentType: Assessment) {
    let deletedValue;
    assessmentType.selected = !assessmentType.selected;
    if (assessmentType.selected) {
      this.selectedValue.push(assessmentType);
    } else {
      deletedValue = assessmentType.value;
    }

    this.stateChange.emit({ state: 'SELECTED_ASSESSMENTS', item: this.selectedValue, deletedItem: deletedValue,
                            assessmentType: this.MultiSelection});
  }
}

export class Assessment {
  constructor(public description: string, public selected?: boolean, public value?: number) {
    if (selected === undefined) selected = false;
  }
}